export default __webpack_public_path__ + "static/Austin-Bold-f44f9c1bf8e803c6e78fb7ef33a46fdb.woff2";